import ModuleController from "../API/organization/ModuleController";
import {mergeModuleCatalogFields} from "./flattenModuleCompositionRow";

export const enrichModuleCompositionRow = async (row) => {
    if (row?.moduleId == null) {
        return row
    }
    try {
        const response = await ModuleController.getById(row.moduleId)
        return mergeModuleCatalogFields(row, response.data)
    } catch {
        return row
    }
}

export const enrichModuleCompositionRows = async (rows) => {
    const list = Array.isArray(rows) ? rows : []
    const moduleIds = [...new Set(list.map((row) => row?.moduleId).filter((id) => id != null))]
    if (moduleIds.length === 0) {
        return list
    }
    const entries = await Promise.all(moduleIds.map((id) =>
        ModuleController.getById(id)
            .then((response) => [id, response.data])
            .catch(() => [id, null])
    ))
    const byId = Object.fromEntries(entries)
    return list.map((row) => mergeModuleCatalogFields(row, byId[row.moduleId]))
}
